import { useEffect, useState } from 'react';
import { getOffers } from 'services/payment-service';

import { logInfo, logError } from 'components/utils/logger';
import { useMember } from 'hooks/member';
import { useQueryDict } from 'hooks/app';

export const usePremiumOffers = () => {
  const [premiumOffers, setPremiumOffers] = useState([]);
  const [premiumOffersVariant, setPremiumOffersVariant] = useState('');
  const { initialized, memberId, email } = useMember();
  const { search } = useQueryDict();
  const [pending, setPending] = useState(false);

  useEffect(() => {
    if (initialized) {
      getOffersData(email, search);

    }
  }, [initialized, memberId, email]);

  const getOffersData = async (email, search) => {
    setPending(true);
    const { errors, ...result } = await getOffers({ email, search });
    if (errors?.length > 0) {
      logError('Error retrieving countries.', errors);
    } else {
      setPremiumOffers(result.premiumOffers);
      setPremiumOffersVariant(result.premiumOffersVariant);
      setPending(false);
    }
  }

  return { premiumOffers, premiumOffersVariant, getPremiumOffersPending: pending };
}

export const useCouponAlert = (premiumOffers) => {
  const { initialized, isLoggedIn, isSoftLoggedIn } = useMember();
  const [couponAlertText, setCouponAlertText] = useState(false);

  useEffect(() => {
    if (initialized && premiumOffers) {
      let couponAlertText = '';
      if (isLoggedIn || isSoftLoggedIn) {
        const specialOffer = premiumOffers.find(o => o.couponTypeName === 'party_like_2001');
        if (specialOffer) {
          couponAlertText = `We're celebrating 20 years! Send your card now to receive our 2001 price! * New annual memberships. Auto-renewals will occur at the standard rate of $20/year`;
          if (!specialOffer.trialPeriodDays) {
            couponAlertText = `We're celebrating 20 years! Send your card now to receive our 2001 price! * New annual memberships. Auto-renewals will occur at the standard rate of $20/year`;
          }
        }
      }
      setCouponAlertText(couponAlertText);
    }
  }, [initialized, isLoggedIn, isSoftLoggedIn, premiumOffers]);

  return { couponAlertText }
}